export default __webpack_public_path__ + "static/media/WBTC.47d82cee.svg";